import { ApiEndPoints, NetworkManager } from "../network";

export class DesignationsService {
  static geDesignationsById = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.getDesignations + id,
      // data: { ...id },
    });
  };
}
